import { buildClientSchema, IntrospectionQuery } from "graphql";
import * as introspection from "../__generated__/graphql.schema.json";

export const schema = buildClientSchema(introspection as unknown as IntrospectionQuery);
